import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  title: string = "Guardando Informação";

  @Input()
  percentage: number = 0;

  hideProgressBar: boolean = false;

  ngOnInit(): void {
  }

}
